import { FC, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, Menu } from '@robocorp/components';
import { NavigationLink } from '~/components/router';
import { useOrganizationsQuery } from '~/queries';
import { SearchRules, fuzzySearchData } from '~/utils/searchUtils';

const mapSearchRules: SearchRules<{ name: string }> = {
  name: { value: (item) => item.name },
};

export const OrganizationSearchResults: FC<{ search: string }> = ({ search }) => {
  const { t } = useTranslation();
  const { data: organizations = [] } = useOrganizationsQuery();

  const onSearch = useCallback(
    (input: string) => fuzzySearchData(mapSearchRules, organizations)(input),
    [organizations],
  );
  const results = useMemo(() => onSearch(search), [onSearch, search]);

  return results.length !== 0 ? (
    <>
      {results.map((organization) => (
        <NavigationLink
          component={Menu.Link}
          key={organization.id}
          to={`/${organization.short_name}`}
          icon={
            organization.details.picture ? (
              <Avatar src={organization.details.picture} alt={organization.name} size="small" />
            ) : (
              <Avatar placeholder={organization.name} size="small" />
            )
          }
        >
          {organization.name}
        </NavigationLink>
      ))}
    </>
  ) : (
    <Menu.Title>{t('noEntries')}</Menu.Title>
  );
};
